import { motion, AnimatePresence } from "framer-motion";
import { Center, Text, TextInput, Tooltip } from "@mantine/core";
import { IconKey, IconUser, IconAlertCircle } from "@tabler/icons-react";
import { useForm } from "@mantine/form";
import { showNotification } from "@mantine/notifications";
import { useEffect } from "react";

function Component(props: any) {
  const form = useForm({
    initialValues: { email: "" },

    // functions will be used to validate values at corresponding key
    validate: {
      email: (value) => (/^\S+@\S+$/.test(value) ? null : "Invalid email"),
    },
  });
  const queryArgs = new URLSearchParams(window.location.search);
  const formatEmail = (emailText: string) => {
    return emailText.toLowerCase();
  };
  return (
    <>
      {queryArgs.get("public_username") !== null ? (
        <Center>
          <Text size="xl">
            The email address that must be used has already been specified.
            Please click next to continue.
          </Text>
        </Center>
      ) : (
        <Center>
          <Text size="xl">
            Please enter the email address
            {queryArgs.get("stage") === "signin"
              ? ""
              : " you would like to use"}{" "}
            for your account.
          </Text>
        </Center>
      )}
      <Center>
        <form>
          <TextInput
            autoCapitalize=""
            autoFocus
            type="email"
            name="email"
            value={props.publicUsername}
            mt="xl"
            size="xl"
            icon={<IconUser scale={50} />}
            placeholder="Email"
            onChange={(e: any) => {
              const formattedEmail = formatEmail(e.currentTarget.value);
              props.setPublicUsername(formattedEmail);
              form.setValues({
                email: formattedEmail,
              });
              if (!/^\S+@\S+$/.test(formattedEmail) ? true : false) {
                props.setFormIsValid(false);
                return;
              }
              props.setFormIsValid(true);
            }}
            onKeyDown={(e: any) => {
              if (e.key === "Enter") {
                props.paginate(1);
              }
            }}
            onBlur={() => {
              if (props.publicUsername.length <= 0) return;
              form.setValues({
                email: props.publicUsername,
              });
              if (!/^\S+@\S+$/.test(props.publicUsername) ? true : false) {
                showNotification({
                  message: "Please provide a valid email",
                  color: "red",
                });
                return;
              }
              props.setFormIsValid(true);
            }}
            rightSection={
              <Tooltip
                label="Must be a valid email address"
                position="top-end"
                withArrow
              >
                <div>
                  <IconAlertCircle
                    size={18}
                    style={{ display: "block", opacity: 0.5 }}
                  />
                </div>
              </Tooltip>
            }
            disabled={queryArgs.get("public_username") !== null}
          />
        </form>
      </Center>
    </>
  );
}

export default Component;
